module.exports = __webpack_public_path__ + "static/carbon-logo-a78ad275798d765d7babebab239275c8.png";